import type { WizardFlowKind } from './wizardCategoryRoute';

const KEY_PREFIX = 'agd:wizardCategorySwitch:';

export type WizardCategorySwitchSnapshot = {
  draftRequestId: string;
  activeFlow: WizardFlowKind;
  draft: Record<string, unknown>;
  savedAt: number;
};

function storageKey(draftRequestId: string): string {
  return `${KEY_PREFIX}${draftRequestId.trim()}`;
}

/** Persist in-memory draft after a cross-type category switch (until save/reload from BE). */
export function saveWizardCategorySwitchSnapshot(snapshot: WizardCategorySwitchSnapshot): void {
  const id = snapshot.draftRequestId.trim();
  if (!id || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(storageKey(id), JSON.stringify(snapshot));
  } catch {
    // Ignore quota / private-mode failures; in-memory draft still works for the session.
  }
}

export function readWizardCategorySwitchSnapshot(
  draftRequestId: string,
): WizardCategorySwitchSnapshot | null {
  const id = draftRequestId.trim();
  if (!id || typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(storageKey(id));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as WizardCategorySwitchSnapshot;
    if (!parsed || parsed.draftRequestId !== id || !parsed.activeFlow || !parsed.draft) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearWizardCategorySwitchSnapshot(draftRequestId: string): void {
  const id = draftRequestId.trim();
  if (!id || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(storageKey(id));
  } catch {
    // ignore
  }
}
